import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { styled } from '@mui/material/styles'
import Header from './header'
import Nav from './nav'

const APP_BAR_MOBILE = 64
const APP_BAR_DESKTOP = 54

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  width: '100%',
  overflow: 'hidden'
})

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE * 2
}))

export default function DefaultLayout () {
  const [open, setOpen] = useState(false)

  return (
    <StyledRoot>
      <Header onOpenNav={() => setOpen(true)} />
      <Nav openNav={open} onCloseNav={() => setOpen(false)} />
      <Main sx={{
        pt: `${(APP_BAR_DESKTOP + 17)}px`
      }}>
        <Outlet />
      </Main>
    </StyledRoot>
  )
}
